export default __webpack_public_path__ + "static/media/voice-ai-bot.a515a0ba.png";